import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.VITE_API_URL,
  validateStatus: (status: number) => {
    if (status === 401) {
      window.location.href = '/logout';
    }
    return status < 500;
  },
});

instance.interceptors.request.use((config) => {
  config.headers['Time-Zone'] =
    Intl.DateTimeFormat().resolvedOptions().timeZone;

  if (!!(window as any)?.ReactNativeWebView) {
    config.headers['Device-Type'] = 'mobile';
  }

  return config;
});

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      window.location.href = '/logout';
    }
    return Promise.reject(error);
  },
);

export default instance;
